const state = {
    currentApplication: {}
};

const actions = {};

const mutations = {
    setCurrentApplication(state, currentApplication) {
        state.currentApplication = currentApplication;
    }
};

/**
 * Main app store data
 */
export default {
    namespaced: true,
    state,
    actions,
    mutations,
};
